import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkhed() {



  const cardData =
  {
    keyword: 'Bus On Rent in Khed / Rajgurunagar',
    heading: 'Sanavi Travels: Bus On Rent in Khed / Rajgurunagar',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Khed / Rajgurunagar, providing safe, comfortable, and spacious transportation for families, groups, corporate outings, school excursions, weddings, and tourist trips across Khed and Rajgurunagar. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Khed, Rajgurunagar, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate travel, and group tours. Choose Sanavi Travels for trusted bus rental services in Khed / Rajgurunagar, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Rajgurunagar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Rajgurunagar Town",
    "description": "Rajgurunagar, also known as Khed, is a historic town in Pune district named in honor of freedom fighter Rajguru. It is located along the banks of the Bhima River and is known for its rich cultural heritage and scenic surroundings. The town serves as a gateway to the Sahyadri hills and lush rural landscapes, offering visitors a glimpse into traditional Maharashtrian life, agriculture, and local customs."
  },
  {
    "title": "Bhima River Bank",
    "description": "The Bhima River flows gracefully near Rajgurunagar, providing scenic spots for picnics, walks, and photography. The riverside is peaceful and ideal for early morning or evening visits. During the monsoon, the river swells with water, enhancing the beauty of the surrounding greenery and hills."
  },
  {
    "title": "Historic Temples in Khed Taluka",
    "description": "Rajgurunagar and its surrounding villages host several historic temples, including ancient Shiva and Ganesh shrines. These temples reflect traditional Maharashtrian architecture and are focal points for local festivals and cultural gatherings."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "The town has vibrant local markets where visitors can explore agricultural produce, handmade crafts, and religious items. These markets provide insight into rural commerce and the lifestyle of the people of Rajgurunagar."
  },
  {
    "title": "Rajgurunagar Fort (Historic Sites Nearby)",
    "description": "While the original fort structures in the region are partially ruined, nearby hill forts and historic sites provide a glimpse of Maratha-era defense architecture. These spots are popular among trekkers, history enthusiasts, and photographers."
  },
  {
    "title": "Maval Hills Viewpoints",
    "description": "Rajgurunagar is surrounded by the scenic Maval hills, offering several viewpoints for trekking and nature walks. These hills provide breathtaking panoramas of valleys, rivers, and farmland, especially during the monsoon season."
  },
  {
    "title": "Adventure and Trekking Spots",
    "description": "The nearby Sahyadri hills offer opportunities for trekking, hiking, and nature exploration. Adventure enthusiasts often visit trails leading to forts, waterfalls, and viewpoints around Rajgurunagar."
  },
  {
    "title": "Agricultural and Rural Tourism",
    "description": "The region around Rajgurunagar is rich in farmland, particularly sugarcane and horticulture crops. Visitors can witness traditional farming practices, rural life, and seasonal festivals that celebrate harvests and local culture."
  },
  {
    "title": "Nearby Temghar and Mulshi Dams",
    "description": "Close to Rajgurunagar are scenic dams like Temghar and Mulshi, which offer boating, nature walks, and sunset views. These spots provide relaxing escapes for families and travelers looking to enjoy natural beauty near the town."
  },
  {
    "title": "Local Cuisine and Eateries",
    "description": "Rajgurunagar offers authentic Maharashtrian cuisine, with local eateries serving traditional snacks, meals, and sweets. Sampling regional dishes provides visitors a taste of local culture and culinary heritage."
  }
]
,



"services": [
{
"name": "Bus On Rent in Khed Rajgurunagar",
"description": "Bus On Rent in Khed Rajgurunagar provides reliable and comfortable bus rental services for local sightseeing, group outings, corporate trips, and long-distance travel. With well-maintained buses, spacious seating, and professional drivers, the service ensures safe, punctual, and hassle-free journeys for families, tourists, corporate clients, and event organizers visiting Khed and nearby destinations. Ideal for day trips, religious tours, and weekend getaways, it focuses on convenience, safety, and a smooth travel experience."
},
{
"name": "Bus Hire Khed",
"description": "Bus Hire Khed offers flexible and convenient bus rental solutions suitable for various travel needs, including picnics, weddings, corporate outings, school trips, and group excursions. Equipped with modern interiors, ample seating, and professional drivers, this service ensures comfort, safety, and timely travel, making it a trusted choice for residents and visitors traveling to and from Khed Rajgurunagar."
},
{
"name": "AC Bus Rajgurunagar",
"description": "AC Bus Rajgurunagar ensures a comfortable and refreshing journey with fully air-conditioned buses. Perfect for long-distance travel, group tours, and corporate trips, these buses offer spacious seating, smooth rides, and a pleasant environment, ensuring a relaxing and enjoyable journey for all passengers visiting Rajgurunagar and surrounding areas."
},
{
"name": "Luxury Bus Khed",
"description": "Luxury Bus Khed provides premium travel with high-end buses featuring reclining seats, ample legroom, and enhanced comfort. Ideal for VIP travel, corporate outings, wedding parties, and leisure tours, it combines elegance, safety, and professional service to provide an elevated travel experience for groups and families."
},
{
"name": "Wedding Bus Khed",
"description": "Wedding Bus Khed offers specialized bus services for wedding guests, pre-wedding events, and destination weddings. Spacious, well-maintained buses with professional drivers ensure comfortable and timely transportation, making it easier for families and friends to travel together without stress or delays during wedding celebrations."
},
{
"name": "Corporate Bus Rajgurunagar",
"description": "Corporate Bus Rajgurunagar caters to businesses and organizations requiring organized transportation for corporate meetings, team outings, conferences, and office travel. With punctual service, professional drivers, and comfortable buses, it ensures smooth and efficient corporate travel within Khed and nearby regions."
},
{
"name": "Outstation Bus Khed",
"description": "Outstation Bus Khed provides dependable long-distance travel services to nearby cities, tourist destinations, and hill stations. With experienced drivers, comfortable seating, and well-maintained buses, it guarantees safe, convenient, and enjoyable journeys for families, tourists, and group travelers exploring destinations beyond Khed."
},
{
"name": "Affordable Bus Rajgurunagar",
"description": "Affordable Bus Rajgurunagar delivers budget-friendly bus rental services without compromising on comfort or safety. Perfect for families, schools, social groups, and religious tours, it combines economical pricing with professional drivers and well-maintained buses for reliable transportation."
},
{
"name": "Chauffeur Driven Bus Khed",
"description": "Chauffeur Driven Bus Khed ensures a stress-free travel experience with trained and professional drivers who manage navigation, traffic, and schedules efficiently. Passengers can relax and enjoy the journey, making it ideal for group travel, corporate trips, religious tours, and leisure excursions."
},
{
"name": "Best Bus Service Rajgurunagar",
"description": "Best Bus Service Rajgurunagar is known for punctual service, clean buses, and a customer-focused approach. Suitable for family trips, group outings, corporate travel, and tourist tours, it guarantees safe, comfortable, and reliable transportation for all types of travelers."
},
{
"name": "Tourist Bus Khed",
"description": "Tourist Bus Khed caters to travelers exploring Khed, Rajgurunagar, and nearby attractions. Flexible itineraries, experienced drivers, and comfortable buses ensure an enjoyable sightseeing experience, allowing tourists to explore local forts, scenic locations, and cultural sites without worrying about logistics."
},
{
"name": "Group Travel Bus Khed",
"description": "Group Travel Bus Khed provides organized transportation for large groups such as families, friends, corporate teams, and tour groups. With spacious seating, coordinated planning, and reliable drivers, it ensures everyone travels safely, comfortably, and together, making group trips smooth and enjoyable."
},
{
"name": "Online Bus Booking Rajgurunagar",
"description": "Online Bus Booking Rajgurunagar allows travelers to reserve buses quickly and conveniently with instant confirmation. Multiple bus options, transparent pricing, and flexible schedules make planning trips hassle-free, saving time and effort for families, tourists, and corporate clients."
},
{
"name": "Event Bus Khed",
"description": "Event Bus Khed offers dedicated transportation for weddings, parties, corporate events, exhibitions, and special occasions. With comfortable buses, professional drivers, and reliable scheduling, it ensures smooth and organized travel for guests and participants attending events in Khed and surrounding areas."
},
{
"name": "Khed Travel Bus",
"description": "Khed Travel Bus provides complete travel solutions for local sightseeing, outstation trips, corporate travel, and group excursions. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, corporate clients, and large groups seeking dependable bus transportation in and around Khed Rajgurunagar."
}
],
"tableData": [
["Bus On Rent in Khed Rajgurunagar", "Bus Hire Khed"],
["AC Bus Rajgurunagar", "Luxury Bus Khed"],
["Wedding Bus Khed", "Corporate Bus Rajgurunagar"],
["Outstation Bus Khed", "Affordable Bus Rajgurunagar"],
["Chauffeur Driven Bus Khed", "Best Bus Service Rajgurunagar"],
["Tourist Bus Khed", "Group Travel Bus Khed"],
["Online Bus Booking Rajgurunagar", "Event Bus Khed"],
["Khed Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Khed / Rajgurunagar with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and affordable bus rental services in Khed / Rajgurunagar, perfect for group outings, school trips, family travel, and corporate tours."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and comfortable journey for all passengers in and around Khed / Rajgurunagar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Khed / Rajgurunagar routes, ensuring safe, punctual, and stress-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for bus rentals in Khed / Rajgurunagar, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, travel queries, and trip planning for your bus hire in Khed / Rajgurunagar."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental options based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Khed / Rajgurunagar."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Khed / Rajgurunagar?',
    answer: 'Yes, Sanavi Travels offers dependable bus rental services in Khed / Rajgurunagar for various travel needs.'
  },
  {
    question: 'How can I book a bus in Khed / Rajgurunagar?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Khed / Rajgurunagar?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Khed / Rajgurunagar?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Khed / Rajgurunagar routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Khed / Rajgurunagar?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Khed / Rajgurunagar and nearby areas.'
  },
  {
    question: 'Is the bus service in Khed / Rajgurunagar available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Khed / Rajgurunagar to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Khed / Rajgurunagar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshpande',
    feedback: 'We rented a bus in Khed / Rajgurunagar from Sanavi Travels—comfortable seats, friendly driver, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Sanavi Travels provided dependable bus rental service in Khed / Rajgurunagar—highly recommended!',
    rating: 5
  }
];












































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Bus On Rent in Khed Rajgurunagar - Sanavi Travels",
  "description": "Sanavi Travels offers AC, luxury, wedding, corporate, and outstation buses on rent in Khed / Rajgurunagar. Chauffeur-driven buses for group travel, tourist trips, events, and online booking at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "36"
  }
};








  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Khed / Rajgurunagar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC, luxury, wedding, corporate, and outstation buses on rent in Khed / Rajgurunagar. Chauffeur-driven buses for group travel, tourist trips, events, and online booking at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/132.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkhed;